import User from "./User";
import Axios from "axios";
import moment from "moment";
import store from "../src/store";

class RequestsClass {

  constructor() {
    this.requests = /** @type {Request[]} */ ([]);
    this.locked = false;
  }

  /**
   * @param {number} id
   */
  get(id) {
    for (let request of this.requests) {
      if (request.id == id) {
        return request;
      }
    }
    return null;
  }

  set(id, data) {
    for (let request of this.requests) {
      if (request.id == id) {
        request.load(data);
        return request;
      }
    }
    return null;
  }

  async init() {
    if (!User.token || this.locked) {
      return;
    }
    try{
      this.locked = true;
      let requests = await Axios.get(CONFIG.urlServer + "/api/user_requests", {
        params: {
          property: store.state.property,
          perPage: 100,
          author: User.id
        },
        headers: {
          "Authorization": "Bearer " + User.token
        }
      });
      let newRequests = [];
      for (let definition of requests.data.data) {
        let newRequest = new Request();
        newRequest.load(definition);
        newRequests.push(newRequest);
      }
      this.requests = newRequests;
      this.locked = false;
    }
    catch(e) {
      console.log(e);
      this.locked = false;
    }
  }

  /**
   * @param {{title: string, body: string, property: string, unit: string, phoneNumber: string, category: number
   *  emergency: boolean, canAccessIfAbsent: boolean, animal: boolean, alarm: boolean, alarmCode: string,
   *  image: {data: string, name: string, type: string, extension: string}}} data
   */
  async createRequest(data) {
    return await Axios.post(CONFIG.urlServer + "/api/user_requests", {
      title: data.title,
      body: data.body,
      status: "pending",
      category: data.category,
      // building: data.building,
      // unit: data.door,
      phoneNumber: data.phoneNumber,
      emergency: data.emergency,
      canAccessIfAbsent: data.canAccessIfAbsent,
      animal: data.animal,
      alarm: data.alarm,
      alarmCode: data.alarmCode,
      image: data.image
        ? {
          file: data.image.data.split("base64,")[1],
          mediaType: data.image.type,
          extension: data.image.extension,
        }
        : null
    }, {
      params: {
        property: store.state.property
      },
      headers: {
        "Authorization": "Bearer " + User.token
      }
    });
  }

  /**
   * @param {Request} request
   */
  async cancelRequest(request) {
    let result = await Axios.put(CONFIG.urlServer + "/api/user_requests/" + request.id, {
      status: request.status
    }, {
      params: {
        property: store.state.property
      },
      headers: {
        "Authorization": "Bearer " + User.token
      }
    });
    return result;
  }

  /**
   * @param {Request} request
   * @param {string} message
   */
  async replyRequest(request, message) {
    let result = await Axios.put(CONFIG.urlServer + "/api/user_requests/" + request.id, {
      reply: message
    }, {
      headers: {
        "Authorization": "Bearer " + User.token
      }
    });
    return result;
  }

}

/**
 * @typedef RequestDefinition
 * @property {number} id
 * @property {string} status
 * @property {string} title
 * @property {string} createdAt
 * @property {string} property
 * @property {string} unit
 * @property {string} phoneNumber
 * @property {string} body
 * @property {boolean} emergency
 * @property {boolean} animal
 * @property {boolean} canAccessIfAbsent
 * @property {boolean} alarm
 * @property {string} alarmCode
 * @property {number} category
 * @property {{tag: string, id: number, name: string, url: string}} image
 * @property {string} decisionNote
 * @property {string} decisionAt
 * @property {any} categoryTree
 * @property {any} discussion
 */

export class Request {

  constructor() {
    this.id = /** @type {number} */ (null);
    this.status = /** @type {string} */ (null);
    this.title = /** @type {string} */ (null);
    this.createdAt = /** @type {string} */ (null);
    this.property = /** @type {string} */ (null);
    this.unit = /** @type {string} */ (null);
    this.phoneNumber = /** @type {string} */ (null);
    this.body = /** @type {string} */ (null);
    this.emergency = /** @type {boolean} */ false;
    this.animal = /** @type {boolean} */ false;
    this.canAccessIfAbsent = /** @type {boolean} */ false;
    this.alarm = /** @type {boolean} */ false;
    this.alarmCode = /** @type {string} */ (null);
    this.category = /** @type {number} */ (null);
    this.image = /** @type {{tag: string, id: number, name: string, url: string}} */ (null);
    this.decisionNote = /** @type {string} */ (null);
    this.decisionAt = /** @type {string} */ (null);
    this.categories = /** @type {any} */ (null);
    this.discussion = /** @type {any} */ (null);
  }

  /**
   * @param {RequestDefinition} definition
   */
  load(definition) {
    this.id = definition.id;
    this.status = definition.status;
    this.title = definition.title;
    this.createdAt = moment(definition.createdAt);
    this.property= definition.property;
    this.unit = definition.unit;
    this.phoneNumber = definition.phoneNumber;
    this.body = definition.body;
    this.emergency = definition.emergency;
    this.animal = definition.animal;
    this.canAccessIfAbsent = definition.canAccessIfAbsent;
    this.alarm = definition.alarm;
    this.alarmCode = definition.alarmCode;
    this.category = definition.category;
    this.image = definition.image ? definition.image.url : null;
    this.decisionNote = definition.decisionNote;
    this.decisionAt = definition.decisionAt;
    this.categories = [];
    this.discussion = definition.discussion;

    // Navigate categories tree if it is defined
    let root = definition.categoryTree;
    if(root) {
      do {
        this.categories.unshift(root.name);
        root = root.parent;
      } while (root != null)
    }

  }

  isDone() {
    return this.status === 'completed' || this.status === 'canceled';
  }

}

let Requests = new RequestsClass();
export default Requests;